import React from 'react';

import { useActiveSession } from '@root/features/authentication/hooks/useActiveSession';

interface AuthProviderProps {
	children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
	const { data } = useActiveSession();

	return <React.Fragment>{children}</React.Fragment>;
};
